import { useContext } from "react";
import { SupplierDashboardContext } from "./SupplierDashboard.context";

export function useSupplierDashboardContext() {
  const context = useContext(SupplierDashboardContext)

  if (!context) {
    throw new Error("useSupplierDashboardContext deve ser utilizado apenas dentro de SupplierDashboardProvider")
  }

  return context
}